import EditorPanelBeliefsValuesDetail from './EditorPanelBeliefsValuesDetail';
import EditorPanelCoreBeliefsDetail from './EditorPanelCoreBeliefsDetail';
import EditorPanelHeroSlidesDetail from './EditorPanelHeroSlidesDetail';
import EditorPanelImageDetail from './EditorPanelImageDetail';
import EditorPanelSermonsDetail from './EditorPanelSermonsDetail';
import EditorPanelVersesDetail from './EditorPanelVersesDetail';
import EditorPanelWatchVideosDetail from './EditorPanelWatchVideosDetail';

export const EDITOR_PANEL_FIELD_DETAILS = {
  'home.hero.slides': EditorPanelHeroSlidesDetail,
  'home.verses.items': EditorPanelVersesDetail,
  'home.sermons.items': EditorPanelSermonsDetail,
  'home.about.image': EditorPanelImageDetail,
  'home.pastor.image': EditorPanelImageDetail,
  'home.pastor.background': EditorPanelImageDetail,
  'story.pastor_image': EditorPanelImageDetail,
  'beliefs.values.items': EditorPanelBeliefsValuesDetail,
  'beliefs.items': EditorPanelCoreBeliefsDetail,
};

const HIDDEN_PANEL_KEYS = /^home\.verse\.\d+\.(text|ref)$/;
const BELIEF_FIELD_KEYS = /^beliefs\.\d+\.(title|description|verse_text|verse_ref)$/;
const WATCH_VIDEOS_KEY = /^watch\.section\.\d+\.videos$/;

export function shouldHideFromEditorPanel(contentKey) {
  return (
    HIDDEN_PANEL_KEYS.test(contentKey) ||
    BELIEF_FIELD_KEYS.test(contentKey) ||
    contentKey === 'beliefs.values.title'
  );
}

export function hasEditorPanelDetail(contentKey) {
  return Boolean(EDITOR_PANEL_FIELD_DETAILS[contentKey]) || WATCH_VIDEOS_KEY.test(contentKey);
}

export function getEditorPanelDetail(contentKey) {
  if (EDITOR_PANEL_FIELD_DETAILS[contentKey]) return EDITOR_PANEL_FIELD_DETAILS[contentKey];
  if (WATCH_VIDEOS_KEY.test(contentKey)) return EditorPanelWatchVideosDetail;
  return null;
}

export function getEditorPanelDetailPreview(contentKey, element) {
  if (contentKey === 'home.hero.slides') {
    const count = element?.querySelectorAll('.hero-slide')?.length || 0;
    return count ? `${count} slides — click to expand` : 'Click to expand';
  }

  if (contentKey === 'home.verses.items') {
    const count = element?.getAttribute('data-verse-count');
    return count ? `${count} verses — click to expand` : 'Click to expand';
  }

  if (contentKey === 'home.sermons.items') {
    const count = element?.querySelectorAll('.video-container')?.length || 0;
    return count ? `${count} videos — click to expand` : 'Click to expand';
  }

  if (WATCH_VIDEOS_KEY.test(contentKey || '')) {
    const count = element?.querySelectorAll('.video-item-wrap:not(.video-item-wrap--add)')?.length || 0;
    return count ? `${count} videos — click to expand` : 'Click to expand';
  }

  if (contentKey === 'beliefs.values.items') {
    const count = element?.getAttribute('data-value-count');
    return count ? `${count} values — click to expand` : 'Click to expand';
  }

  if (contentKey === 'beliefs.items') {
    const count = element?.getAttribute('data-belief-count');
    return count ? `${count} beliefs — click to expand` : 'Click to expand';
  }

  if (contentKey === 'home.about.image' || contentKey === 'home.pastor.image' || contentKey === 'story.pastor_image') {
    return 'Click to expand — preview & replace';
  }

  if (contentKey === 'home.pastor.background') {
    return 'Click to expand — background image';
  }

  return 'Click to expand';
}
